import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const AuthContext = createContext();

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8080/";

const AuthContextProvider = (props) => {
  const [isAuthenticated, setisAuthenticated] = useState(
    window.localStorage.getItem("token") ? true : false
  );
  const [isLoading, setisLoading] = useState(false);
  const [isSuperAdmin, setisSuperAdmin] = useState(false);
  const [isVerified, setisVerified] = useState(false);
  const [authError, setisauthError] = useState("");
  const [token, setToken] = useState("");
  const [user, setUser] = useState({});

  const changeUser = (newUser) => {
    setUser({
      ...user,
      username: newUser.username,
      email: newUser.email,
      first_name: newUser.first_name,
      last_name: newUser.last_name,
    });
  };

  const verify = (token) => {
    setisLoading(true);

    let mounted = true;
    let source = axios.CancelToken.source();

    axios
      .post(API_URL + "verify", { token: token }, { cancelToken: source.token })
      .then((res) => {
        if (mounted) {
          setToken(token);
          setUser(res.data.user);
          setisAuthenticated(true);
          setisVerified(true);
          if (res.data.user.type === "super_admin") {
            setisSuperAdmin(true);
          } else {
            setisSuperAdmin(false);
          }
          setisLoading(false);
        }
      })
      .catch((error) => {
        let err = !error.response
          ? "Error: Network Error"
          : error.response.data;

        setisauthError(err);
        setToken("");
        setUser({});
        setisAuthenticated(false);
        window.localStorage.clear();
        setisVerified(false);
        setisLoading(false);
      });

    //Cancel axios request when component unmounted
    return () => {
      mounted = false;
      source.cancel();
    };
  };

  const login = (inputUsername, inputPassword, rememberMe) => {
    axios
      .post(API_URL + "login", {
        username: inputUsername,
        password: inputPassword,
        rememberMe,
      })
      .then((res) => {
        setToken(res.data.token);
        setUser(res.data.user);
        setisAuthenticated(true);
        setisVerified(true);
        if (res.data.user.type === "super_admin") {
          setisSuperAdmin(true);
        } else {
          setisSuperAdmin(false);
        }
        window.localStorage.setItem("token", res.data.token);
      })
      .catch((error) => {
        let err = !error.response
          ? "Error: Network Error"
          : error.response.data?.error || error.response.data;
        setisauthError(err);
      });
  };

  const logout = () => {
    setisauthError("");
    setToken("");
    setUser([]);
    setisAuthenticated(false);
    setisVerified(false);
    setisLoading(false);
    setisSuperAdmin(false);
    window.localStorage.clear();
  };

  useEffect(() => {
    const savedToken = window.localStorage.getItem("token");
    if (savedToken) {
      verify(savedToken);
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        authError,
        isLoading,
        isAuthenticated,
        isVerified,
        isSuperAdmin,
        login,
        logout,
        verify,
        changeUser,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
